<script setup lang="ts">
import { ref, Ref, watch, computed, onMounted,} from 'vue';
import { Head, Link, router, usePage } from '@inertiajs/vue3';
import { useTheme, useDisplay } from 'vuetify'
import {Channel} from 'laravel-echo'
import { useThemeStore } from '@/Stores/Theme';
import { SharedPageProps } from '@/Types/inertia';
import { Team } from '@/Types/Models/team';
import { useAuth } from '@/Composables/Auth';
import axios from '@/Plugins/axios';
import { pageTitle, sidebarDrawer, isTouchDevice, containerGapClass, resetContainerGapClass, usePageLayout } from '@/Composables/PageMeta';
import helpers from '@/Plugins/helpers';
import eventBus from '@/Plugins/eventBus';
import { toast } from 'vue3-toastify';

const page = usePage<SharedPageProps>()

const display = useDisplay();
const { auth, isLoggedIn, authRoles, isSuperadmin, isAdmin, logo, brandName, permissions } = useAuth();

const logout = () => {
    router.post(route('logout'));
};
const theme = useTheme();
const themeStore = useThemeStore();
document.documentElement.setAttribute('data-theme', themeStore.getColorScheme);
watch(() => themeStore.getColorScheme, (newValue) => {
    theme.global.name.value = themeStore.getColorScheme;
    document.documentElement.setAttribute('data-theme', themeStore.getColorScheme);
});
const initialSidebarDrawer = () => {
    if(display.mdAndUp.value){
        sidebarDrawer.value = true;
    }
    else{
        sidebarDrawer.value = false;
    }
}
initialSidebarDrawer();

const toggleSidebar = () => {
    if(display.mdAndUp.value){
        themeStore.setSidebarOnlyIcon(!(themeStore.getSidebarOnlyIcon));
        sidebarDrawer.value = true;
    }
    else{
        sidebarDrawer.value = ! sidebarDrawer.value;
    }
};

const sidebarRail = computed(() => {
    if(display.mdAndUp.value){
        return themeStore.getSidebarOnlyIcon;
    }
    else{
        return false;
    }
});

let notificationChannel : Channel;


const toolbarTitleClass = computed(() => {
    if(display.mdAndUp.value){
        return `fs-3 fw-regular`;
    }
    else if(display.smAndUp.value){
        return `fs-2 fw-regular`;
    }
    else{
        return `fs-1 fw-regular`;
    }
});

resetContainerGapClass();
router.on('start', (event) => {
    initialSidebarDrawer();
});
usePageLayout();




const quickPanel = ref(false);
const quickPanelLoading = ref(false);
const openQuickPanel = () => {
    // quickPanel.value = true;
    quickPanelLoading.value = true;
    getQuickPanelContent();
}
const closeQuickPanel = () => {
    quickPanel.value = false;
}
const wallet = ref({
    prepay_amount: 0,
    prepay_balance: 0,
    card_balance: 0,
    usable_balance: 0,
    system_balance: 0,
});
const getQuickPanelContent = () => {

    axios.post(route('quickPanelContent')).then(({data}) => {
        let content = data.data;
        wallet.value.prepay_amount = content.wallet.prepay_amount;
        wallet.value.prepay_balance = content.wallet.prepay_balance;
        wallet.value.card_balance = content.wallet.card_balance;
        wallet.value.usable_balance = content.wallet.usable_balance;
        wallet.value.system_balance = content.system_balance ?? 0;
    })
    .catch((reason) => {
        console.log('error', reason)
    })
    .finally(() => {
        quickPanelLoading.value = false;
    });
}
const warningPanel = ref(false);

const oldLayout = ref(false);
// setInterval(() => {
//     console.log(themeStore.getColorScheme.value)
// }, 1000)

const isCurrentRoute = (name: string) => {
    return window.route().current(name);
}
const groupMenuActive = ref<string[]>([]);
router.on('navigate', (event) => {
    let _groupMenuActive = [];
    if(isCurrentRoute('epcStabilizer.fingerprints.*')){
        _groupMenuActive.push('epcStabilizer');
    }
    groupMenuActive.value = _groupMenuActive;
});

</script>

<template>
    <div>
        <Head :title="pageTitle ?? ''"></Head>

        <div class="main-layout min-h-screen bg-background d-flex flex-column" :class="{'touchless-device': !isTouchDevice}">
            <v-layout>
                <v-navigation-drawer
                    class="app-main-side-menu bg-topbar"
                    v-model="sidebarDrawer"
                    mobile-breakpoint="md"
                    expand-on-hover
                    :rail="sidebarRail"
                    :rail-width="65"
                    :style="{
                        height: '140% !important'
                    }"
                    v-if="isLoggedIn"
                >
                    <div class="h-screen d-flex flex-column">
                        <v-list class="border-b-thin border-divider-light top-logo-list flex-none">
                            <v-list-item class="top-logo-item ps-5">
                                <div class="logo-container">
                                    <div class="logo-icon-wrapper">
                                        <div class="logo-icon">
                                            <img class="logo-img" :src="logo.icon" :alt="brandName">
                                        </div>
                                    </div>
                                    <div class="logo-full-wrapper">
                                        <div class="logo-full">
                                            <img class="logo-img" :src="logo.full" :alt="brandName">
                                        </div>
                                    </div>
                                </div>
                                <div class="logo-text flex-grow-1">
                                    <div class="logo-text-container">{{ brandName }}</div>
                                </div>
                            </v-list-item>
                        </v-list>
                        <div class="flex-grow-1 menu-list overflow-x-hidden" :style="{
                            paddingLeft: '12px',
                            paddingRight: '12px',
                        }">
                            <v-list density="compact" nav class="menubar d-flex flex-column min-h-100 px-0" min-width="40px"  v-model:opened="groupMenuActive">
                                <!-- <v-list-subheader class="text-caption text-primary">
                                    PERSONEL
                                </v-list-subheader> -->
                                
                                <Link  class="v-list-item-n-link" :href="route('admins.index')" v-if="permissions.canCreateAdmin">
                                    <v-list-item title="Admins" value="admins" :active="route().current('admins.index')">
                                        <template #prepend>
                                            <mdi-icon>person</mdi-icon>
                                        </template>
                                    </v-list-item>
                                </Link>
                                <Link  class="v-list-item-n-link" :href="route('billers.index')" v-if="permissions.canCreateBiller">
                                    <v-list-item title="Billers" value="billers" :active="route().current('billers.index')">
                                        <template #prepend>
                                            <mdi-icon>business_center</mdi-icon>
                                        </template>
                                    </v-list-item>
                                </Link>
                                <Link  class="v-list-item-n-link" :href="route('bank_accounts.index')" v-if="permissions.canCreateBankAccount">
                                    <v-list-item title="Bank Accounts" value="bank_accounts" :active="route().current('bank_accounts.index')">
                                        <template #prepend>
                                            <mdi-icon>account_balance</mdi-icon>
                                        </template>
                                    </v-list-item>
                                </Link>
                                <Link  class="v-list-item-n-link" :href="route('companies.superadmin.index')" v-if="isSuperadmin">
                                    <v-list-item title="Companies" value="companies_superadmin" :active="route().current('companies.superadmin.index')">
                                        <template #prepend>
                                            <mdi-icon>storefront</mdi-icon>
                                        </template>
                                    </v-list-item>
                                </Link>
                                <Link  class="v-list-item-n-link" :href="route('invoices.superadmin.index')" v-if="isSuperadmin">
                                    <v-list-item title="Invoices" value="invoices_superadmin" :active="route().current('invoices.superadmin.index')">
                                        <template #prepend>
                                            <mdi-icon>receipt_long</mdi-icon>
                                        </template>
                                    </v-list-item>
                                </Link>
                                <Link  class="v-list-item-n-link" :href="route('companies.index')" v-if="permissions.canCreateCompany">
                                    <v-list-item title="Companies" value="companies" :active="route().current('companies.index')">
                                        <template #prepend>
                                            <mdi-icon>storefront</mdi-icon>
                                        </template>
                                    </v-list-item>
                                </Link>
                                <Link  class="v-list-item-n-link" :href="route('invoices.index')" v-if="permissions.canCreateInvoice">
                                    <v-list-item title="Invoices" value="invoices" :active="route().current('invoices.index')">
                                        <template #prepend>
                                            <mdi-icon>receipt_long</mdi-icon>
                                        </template>
                                    </v-list-item>
                                </Link>
                                <Link  class="v-list-item-n-link" :href="route('paymentRequests.index')" v-if="permissions.canCreatePaymentRequest">
                                    <v-list-item title="Payment Requests" value="paymentRequests" :active="route().current('paymentRequests.index')">
                                        <template #prepend>
                                            <mdi-icon>contact_support</mdi-icon>
                                        </template>
                                    </v-list-item>
                                </Link>
                                <Link  class="v-list-item-n-link" :href="route('paymentRequests.superadmin.index')" v-if="isSuperadmin">
                                    <v-list-item title="Payment Requests" value="paymentRequests_superadmin" :active="route().current('paymentRequests.superadmin.index')">
                                        <template #prepend>
                                            <mdi-icon>contact_support</mdi-icon>
                                        </template>
                                    </v-list-item>
                                </Link>
                                <Link  class="v-list-item-n-link" :href="route('fx-trades.index')" v-if="permissions.hasFxTrade">
                                    <v-list-item title="Fx Trades" value="fx-trades" :active="route().current('fx-trades.index')">
                                        <template #prepend>
                                            <mdi-icon>timeline</mdi-icon>
                                        </template>
                                    </v-list-item>
                                </Link>
                                <Link class="v-list-item-n-link mt-auto" :href="route('profile.show')">
                                        <v-list-item title="Profile" value="profile" :active="route().current('profile.show')">
                                            <template #prepend>
                                                <mdi-icon>person</mdi-icon>
                                            </template>
                                        </v-list-item>
                                    </Link>
                                <Link v-if="isSuperadmin" class="v-list-item-n-link " :href="route('settings.index')">
                                    <v-list-item title="Settings" value="setting" :active="route().current('settings.index')">
                                        <template #prepend>
                                            <mdi-icon>settings</mdi-icon>
                                        </template>
                                    </v-list-item>
                                </Link>
                                <v-list-item link title="Logout"  @click.prevent="logout">
                                    <template #prepend>
                                        <mdi-icon>logout</mdi-icon>
                                    </template>
                                </v-list-item>
                            </v-list>
                        </div>
                    </div>

                    
                </v-navigation-drawer>
                <v-app-bar elevation="0" class="border-b-thin border-divider pe-2 pe-lg-11 bg-topbar app-top-bar" v-if="isLoggedIn">
                    <v-btn density="comfortable" variant="text" icon rounded="pill" color="on-body" @click.stop="toggleSidebar" class="app-main-side-menu-toggler">
                        <mdi-icon v-if="!sidebarDrawer || themeStore.getSidebarOnlyIcon">menu</mdi-icon>
                        <mdi-icon v-else>menu_open</mdi-icon>
                    </v-btn>
                    <div v-if="!$vuetify.display.mdAndUp" class="d-flex flex-row align-center top-logo-app-bar">
                        <div class="top-logo">
                            <img :src="logo.icon" alt="Logo" class="top-logo-img">
                        </div>
                    </div>
                    <v-toolbar-title class="ms-2 ms-md-1" :class="toolbarTitleClass">
                        {{ pageTitle }}
                    </v-toolbar-title>

                    <slot name="toolbar"></slot>

                    <div class="d-flex ga-1 ga-lg-3 align-center">

                        <v-btn variant="text" density="comfortable" icon rounded="pill" color="on-body" v-if="display.smAndUp.value">
                            <mdi-icon v-if="themeStore.getTrueColorScheme == 'light'">light_mode</mdi-icon>
                            <mdi-icon v-else-if="themeStore.getTrueColorScheme == 'dark'">dark_mode</mdi-icon>
                            <mdi-icon v-else>brightness_auto</mdi-icon>

                            <v-menu activator="parent">
                                <v-list min-width="140px">
                                    <v-list-item title="Light" value="light" :active="themeStore.getTrueColorScheme == 'light'" @click="themeStore.setColorScheme('light')">
                                        <template #prepend>
                                            <mdi-icon>light_mode</mdi-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item title="Dark" value="dark" :active="themeStore.getTrueColorScheme == 'dark'" @click="themeStore.setColorScheme('dark')">
                                        <template #prepend>
                                            <mdi-icon>dark_mode</mdi-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item title="System" value="system" :active="themeStore.getTrueColorScheme == ''" @click="themeStore.setColorScheme('')">
                                        <template #prepend>
                                            <mdi-icon>brightness_auto</mdi-icon>
                                        </template>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-btn>
                        <v-btn variant="plain" icon rounded="pill" color="on-body" class="top-propic-app-bar">
                            <v-avatar v-if="page.props?.jetstream?.managesProfilePhotos" size="small" rounded="circle" :image="page.props.auth?.user?.profile_photo_url ?? ''" :alt="page.props.auth?.user?.name"></v-avatar>
                            <mdi-icon v-else size="4">account_circle</mdi-icon>

                            <v-menu activator="parent">
                                <v-list>
                                    <Link class="v-list-item-n-link" :href="route('profile.show')">
                                        <v-list-item title="Profile" value="profile" :active="route().current('profile.show')">
                                            <template #prepend>
                                                <mdi-icon>person</mdi-icon>
                                            </template>
                                        </v-list-item>
                                    </Link>
                                    <Link class="v-list-item-n-link" :href="route('api-tokens.index')" v-if="page.props.jetstream?.hasApiFeatures" v-show="false">
                                        <v-list-item title="API Tokens" value="apiTokens" :active="route().current('api-tokens.index')">
                                            <template #prepend>
                                                <mdi-icon>key_vertical</mdi-icon>
                                            </template>
                                        </v-list-item>
                                    </Link>
                                    <Link v-if="isSuperadmin" class="v-list-item-n-link" :href="route('settings.index')">
                                        <v-list-item title="Settings" value="setting" :active="route().current('settings.index')">
                                            <template #prepend>
                                                <mdi-icon>settings</mdi-icon>
                                            </template>
                                        </v-list-item>
                                    </Link>
                                    <template v-if="display.xs.value">
                                        <divider></divider>
                                        <v-list-item title="Light" value="light" :active="themeStore.getTrueColorScheme == 'light'" @click="themeStore.setColorScheme('light')">
                                            <template #prepend>
                                                <mdi-icon>light_mode</mdi-icon>
                                            </template>
                                        </v-list-item>
                                        <v-list-item title="Dark" value="dark" :active="themeStore.getTrueColorScheme == 'dark'" @click="themeStore.setColorScheme('dark')">
                                            <template #prepend>
                                                <mdi-icon>dark_mode</mdi-icon>
                                            </template>
                                        </v-list-item>
                                        <v-list-item title="System" value="system" :active="themeStore.getTrueColorScheme == ''" @click="themeStore.setColorScheme('')">
                                            <template #prepend>
                                                <mdi-icon>brightness_auto</mdi-icon>
                                            </template>
                                        </v-list-item>
                                        <divider></divider>
                                    </template>
                                    <v-list-item link title="Logout" @click.prevent="logout">
                                        <template #prepend>
                                            <mdi-icon>logout</mdi-icon>
                                        </template>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-btn>
                    </div>
                    
                </v-app-bar>
                <v-main class="d-flex flex-column">
                    <div class="d-flex flex-column flex-grow-1 main-container-wrapper" :class="[containerGapClass]">
                        <v-container class="pa-0 d-flex flex-column flex-grow-1 main-container">
                            <slot></slot>
                        </v-container>
                    </div>
                </v-main>
            </v-layout>
        </div>
    </div>
</template>
